import { createFileRoute, useParams } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { TutorPage } from "@/components/tutor/tutor-page";
import { requireRole } from "@/lib/session";

export const Route = createFileRoute("/parent/tutor/$threadId")({
  ssr: false,
  beforeLoad: () => requireRole("parent"),
  head: () => ({ meta: [{ title: "MAKAI Tutor · MAKAI Parents" }] }),
  component: Page,
});

function Page() {
  const { threadId } = useParams({ from: "/parent/tutor/$threadId" });
  return (
    <AppShell role="parent" title="MAKAI Tutor" subtitle="Insights & support for your child's journey">
      <TutorPage role="parent" threadId={threadId} />
    </AppShell>
  );
}
